export class SearchDefaults {
    public static readonly TAKE = 20;
  }
  